// Pre-screen question type ids. There is no endpoint listing them, so they are hardcoded.
// Multiple select questions are never scored (score = null, enable_evaluation = false).
export const QUESTION_TYPE_MULTIPLE_SELECT = "8d3f6a2e-4c71-4b9e-a5d2-1f7c0e9b6a43";
